import { render, staticRenderFns } from "./CallDownloadLink.vue?vue&type=template&id=656e3cf8&"
import script from "./CallDownloadLink.vue?vue&type=script&lang=ts&"
export * from "./CallDownloadLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports